import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { PaymentStatus } from '../../../services/dto/payment-status';
import { CamPaymentStatusComponent } from '../../payment-status/payment-status.component';

@Component({
  host: { 'data-cid': 'grid-payment-status-cell' },
  imports: [CamPaymentStatusComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-billings-payment-status [status]="this.status"></cam-billings-payment-status>
  </div>`,
})
export class GridPaymentStatusCellComponent extends AbstractCellComponent<unknown, PaymentStatus> {
  get status() {
    return this.value ?? PaymentStatus.Unknown;
  }
}
